import { Domain } from "~/atoms/icons/CustomIcons";
import { Cpanel } from "~/atoms/icons/CustomIcons";

export const serviceIcon = (description) => {
  if (description === "domain name registration") return <Domain />;
  if (description === "web hosting control panel software") return <Cpanel />;
};
